import { __ } from '@wordpress/i18n';
import { RawHTML, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody, __experimentalUnitControl as UnitControl, __experimentalNumberControl as NumberControl } from '@wordpress/components';

export const edit = ({ clientId, attributes, setAttributes }) => {

    const {
        id,
        menuItemNum,
        megaMenuInnerWidth,
        megaMenuBGcolor,
        megaMenuPadding,
        megaMenuIconSize,
        megaMenuLabelSize,
        megaMenuContentGap,
        megaMenuListItemGap,
        megaMenuListBorderRadius,
        megaMenuLinksColor,
        megaMenuLinksHoverColor,
        megaMenuDropdownColor,
        megaMenuDropdownHoverColor,
        megaMenuListBGColor,
        megaMenuBorderColor,
        megaMenuIconColor,
        megaMenuIconHoverColor,
        megaMenuIconBGColor,
        megaMenuBottomBorderColor

    } = attributes;

    useEffect(() => {
      if (!id) {
          // Set unique ID through block index only once.
          let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
          setAttributes({ id: 'hfcmm-' + clientIdSliced });
      }
    }, [id, clientId, setAttributes]);

    // Defined Block Props.
    const blockProps = useBlockProps();

    const ALLOWED_BLOCKS = [
        'core/group',
        'core/columns',
        'core/column',
        'core/list',
        'core/list-item',
        'core/image',
        'core/heading',
        'core/paragraph'
    ];

    const TEMPLATE = [['core/group', {
        className: 'hfc-mm-3'
    }, [
        ['core/columns', {
            verticalAlignment: 'center',
            className: 'hfc-mm-cols'
        }, [
          [
            "core/column",
            {
              width: "25%",
              className: "hfc-mm-col",
            },
            [
              [
                "hfc-blocks/icon-list",
                {},
                [
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Content Features",
                      icon: "faFile",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Generate Bulk Articles",
                      icon: "faFileImage",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Write Single Article",
                      icon: "faFileZipper",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Article Heading Control",
                      icon: "faHeading",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Custom Post Title Pattern",
                      icon: "faSignsPost",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Plagiarism-Free Ai Articles",
                      icon: "faFileExport",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "SEO Optimized AI Articles",
                      icon: "faMagnifyingGlass",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Add Focus Keywords",
                      icon: "faDatabase",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Readable Articles",
                      icon: "faCheckDouble",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Custom Slug Option",
                      icon: "faHammer",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Publish Post Type",
                      icon: "faBlog",
                    },
                  ],
                ],
              ],
            ],
          ],
          [
            "core/column",
            {
              width: "25%",
              className: "hfc-mm-col",
            },
            [
              [
                "hfc-blocks/icon-list",
                {},
                [
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "General Features",
                      icon: "faGear",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Generate Bulk Articles",
                      icon: "faFileImage",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Write Single Article",
                      icon: "faFileZipper",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Article Heading Control",
                      icon: "faHeading",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Custom Post Title Pattern",
                      icon: "faSignsPost",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Plagiarism-Free Ai Articles",
                      icon: "faFileExport",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "SEO Optimized AI Articles",
                      icon: "faMagnifyingGlass",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Add Focus Keywords",
                      icon: "faDatabase",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Readable Articles",
                      icon: "faCheckDouble",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Custom Slug Option",
                      icon: "faHammer",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Publish Post Type",
                      icon: "faBlog",
                    },
                  ],
                ],
              ],
            ],
          ],
          [
            "core/column",
            {
              width: "25%",
              className: "hfc-mm-col",
            },
            [
              [
                "hfc-blocks/icon-list",
                {},
                [
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Integration Features",
                      icon: "faPlug",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Generate Bulk Articles",
                      icon: "faFileImage",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Write Single Article",
                      icon: "faFileZipper",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Article Heading Control",
                      icon: "faHeading",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Custom Post Title Pattern",
                      icon: "faSignsPost",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Plagiarism-Free Ai Articles",
                      icon: "faFileExport",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "SEO Optimized AI Articles",
                      icon: "faMagnifyingGlass",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Add Focus Keywords",
                      icon: "faDatabase",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Readable Articles",
                      icon: "faCheckDouble",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Custom Slug Option",
                      icon: "faHammer",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Publish Post Type",
                      icon: "faBlog",
                    },
                  ],
                ],
              ],
            ],
          ],
          [
            "core/column",
            {
              width: "25%",
              className: "hfc-mm-col",
            },
            [
              [
                "hfc-blocks/icon-list",
                {},
                [
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Advanced Features",
                      icon: "faRocket",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Generate Bulk Articles",
                      icon: "faFileImage",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Write Single Article",
                      icon: "faFileZipper",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Article Heading Control",
                      icon: "faHeading",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Custom Post Title Pattern",
                      icon: "faSignsPost",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Plagiarism-Free Ai Articles",
                      icon: "faFileExport",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "SEO Optimized AI Articles",
                      icon: "faMagnifyingGlass",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Add Focus Keywords",
                      icon: "faDatabase",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Readable Articles",
                      icon: "faCheckDouble",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Custom Slug Option",
                      icon: "faHammer",
                    },
                  ],
                  [
                    "hfc-blocks/list-item",
                    {
                      spanText: "Publish Post Type",
                      icon: "faBlog",
                    },
                  ],
                ],
              ],
            ],
          ],
        ]]
    ]]];

    const hfcmmDynamicStyles = `#${id}.hfc-mega-menu .hfc-mm-3{
        background-color: ${megaMenuBGcolor};
        padding: ${megaMenuPadding}px;
        border-radius: 10px;
        box-shadow: 0px 13px 34px 0px rgba(0, 0, 0, 0.35);
        border-top: 5px solid ${megaMenuBorderColor};
        width: ${megaMenuInnerWidth};
        margin: 0px auto!important;
    }
   .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label,
   .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label,
   .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label{
        position: relative;
        line-height: 30px;
        display: block;
    }
    .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after,
    .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after,
    .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 5px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${megaMenuDropdownColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after{
        border-color: ${megaMenuDropdownHoverColor};
    }
     #${id} .hfc-mm-3 .hfc-mm-cols{
        gap: 10px;
     }
     #${id} .hfc-mm-3 .hfc-icon-list-main .fp-ip-inner .fp-ip-icon{
        background-color: ${megaMenuIconBGColor}!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .fp-ip-inner svg{
        color: ${megaMenuIconColor}!important;
        height: ${megaMenuIconSize}px!important;
        width: ${megaMenuIconSize}px!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:not(:first-child):hover svg{
        color: ${megaMenuIconHoverColor}!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:first-child:hover .fp-ip-inner svg{
        color: ${megaMenuIconColor}!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:not(:first-child):hover{
        background-color: ${megaMenuListBGColor};
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:not(:first-child) span{
        color: ${megaMenuLinksColor};
        font-size: ${megaMenuLabelSize}px;
        font-weight: normal;
     }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:first-child .fp-ip-inner span {
       color: ${megaMenuLinksColor}!important;
       font-size: calc(${megaMenuLabelSize}px + 4px)!important;
       font-weight: bold!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:first-child .fp-ip-inner svg {
      height: calc(${megaMenuIconSize}px + 4px)!important;
      width: calc(${megaMenuIconSize}px + 4px)!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:first-child .fp-ip-inner:hover span{
        color: ${megaMenuLinksColor}!important;
     }
     #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:not(:first-child):hover span{
        color: ${megaMenuLinksHoverColor}!important;
     }
     #${id} .hfc-mm-3 .hfc-icon-list-main .fp-ip-inner{
        gap: ${megaMenuContentGap}px;
        padding: calc(${megaMenuPadding}px - 15px);
    }
     #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:not(:last-child){
        border-bottom: 1px solid ${megaMenuBottomBorderColor};   
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:first-child{
        border-bottom: none;   
    }
    #${id} .hfc-mm-3 .hfc-mm-col{
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        background-color: ${megaMenuBGcolor};
        border: 1px solid ${megaMenuBottomBorderColor};
        border-radius: ${megaMenuListBorderRadius}px;
        padding: 10px;
    }
   #${id} .hfc-mm-3 .hfc-icon-list-main{
        gap: ${megaMenuListItemGap}px;
   }
   .editor-styles-wrapper #${id} .wp-block{
       margin: unset;
   }
    #${id} .wp-block-columns.hfc-mm-cols .hfc-mm-col > .wp-block{
        margin: 0px;
    }
    /* Edit Page Compatibility */
     .editor-styles-wrapper .wp-block-hfc-blocks-mega-menu-3{
        max-width: 1200px!important;
    }
    .editor-styles-wrapper #${id} .hfc-mm-3 .hfc-icon-list-main .block-editor-block-list__layout{
        gap: ${megaMenuListItemGap}px;
        margin-top: 0px;
   }
    .editor-styles-wrapper .hfc-mm-3,
    .editor-styles-wrapper .hfc-mm-3 .hfc-mm-cols{
       max-width: 100%;
    }
    .editor-styles-wrapper .hfc-mm-3 .wp-block-group__inner-container{
        max-width: 100%!important;
    }`;

    return ([
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Cross Rating Block Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
                >
                <NumberControl
                    label={__('Menu Item Number')}
                    isShiftStepEnabled={ true }
                    onChange={newValue => setAttributes({ menuItemNum: newValue })}
                    shiftStep={ 1 }
                    value={ menuItemNum }
                    />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Padding (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ megaMenuPadding: newValue })}
                    isDragEnabled
                    value={megaMenuPadding}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Mega Menu Icon Size (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ megaMenuIconSize: newValue })}
                    isDragEnabled
                    value={megaMenuIconSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Mega Menu Label Size (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ megaMenuLabelSize: newValue })}
                    isDragEnabled
                    value={megaMenuLabelSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Mega Menu Content Gap (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ megaMenuContentGap: newValue })}
                    isDragEnabled
                    value={megaMenuContentGap}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Mega Menu List Items Gap (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({megaMenuListItemGap: newValue })}
                    isDragEnabled
                    value={megaMenuListItemGap}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>List Item Border Radius (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({megaMenuListBorderRadius: newValue })}
                    isDragEnabled
                    value={megaMenuListBorderRadius}
                    className={'frhd__component frhd__component-width-90'}
                /> 
                <UnitControl
                    label={__('Mega Menu Inner Width :')}
                    onChange={newValue => setAttributes({ megaMenuInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={megaMenuInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                  <Heading className={'frhd__pb-heading'}>Mega Menu Background Color :</Heading>
                <ColorPalette
                    value={megaMenuBGcolor}
                    onChange={(colorValue) => setAttributes({ megaMenuBGcolor: colorValue })}
                    clearable={false}
                />
                  <Heading className={'frhd__pb-heading'}>List Item Color :</Heading>
                <ColorPalette
                    value={megaMenuLinksColor}
                    onChange={(colorValue) => setAttributes({megaMenuLinksColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>List Item Hover Color :</Heading>
                <ColorPalette
                    value={megaMenuLinksHoverColor}
                    onChange={(colorValue) => setAttributes({ megaMenuLinksHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Items Hover Background Color :</Heading>
                <ColorPalette
                    value={megaMenuListBGColor}
                    onChange={(colorValue) => setAttributes({ megaMenuListBGColor: colorValue })}
                    clearable={false}
                />
                  <Heading className={"frhd__pb-heading"}>Dropdown Color :</Heading>
                <ColorPalette
                    value={megaMenuDropdownColor}
                    onChange={(colorValue) =>
                    setAttributes({megaMenuDropdownColor: colorValue })
                    }
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Dropdown Hover Color :</Heading>
                <ColorPalette
                    value={megaMenuDropdownHoverColor}
                    onChange={(colorValue) => setAttributes({ megaMenuDropdownHoverColor: colorValue })}
                    clearable={false}
                />
                  <Heading className={'frhd__pb-heading'}>Mega Menu Border Color :</Heading>
                <ColorPalette
                    value={megaMenuBorderColor}
                    onChange={(colorValue) => setAttributes({ megaMenuBorderColor: colorValue })}
                    clearable={false}
                />
                  <Heading className={'frhd__pb-heading'}>Items Border Color :</Heading>
                <ColorPalette
                    value={megaMenuBottomBorderColor}
                    onChange={(colorValue) => setAttributes({megaMenuBottomBorderColor: colorValue })}
                    clearable={false}
                />
                  <Heading className={'frhd__pb-heading'}>Icons Color :</Heading>
                <ColorPalette
                    value={megaMenuIconColor}
                    onChange={(colorValue) => setAttributes({ megaMenuIconColor: colorValue })}
                    clearable={false}
                />
                  <Heading className={'frhd__pb-heading'}>Icon Hover Color :</Heading>
                <ColorPalette
                    value={megaMenuIconHoverColor}
                    onChange={(colorValue) => setAttributes({megaMenuIconHoverColor: colorValue })}
                    clearable={false}
                />
            </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`}>
            <RawHTML>{`<style>${hfcmmDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-mega-menu'}>
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS}
                    template={TEMPLATE}
                    />
            </div>
        </div>
    ])
}

export const save = ({ attributes }) => {

    const {
        id,
        menuItemNum,
        megaMenuInnerWidth,
        megaMenuBGcolor,
        megaMenuPadding,
        megaMenuIconSize,
        megaMenuLabelSize,
        megaMenuContentGap,
        megaMenuListItemGap,
        megaMenuListBorderRadius,
        megaMenuLinksColor,
        megaMenuLinksHoverColor,
        megaMenuDropdownColor,
        megaMenuDropdownHoverColor,
        megaMenuListBGColor,
        megaMenuBorderColor,
        megaMenuBottomBorderColor,
        megaMenuIconColor,
        megaMenuIconBGColor,
        megaMenuIconHoverColor
    } = attributes;

    const hfcmmDynamicStyles = `#${id}.hfc-mega-menu{
        display: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 0;
        top: 25px;
    }
    .hfc-main-header-2 #${id}.hfc-mega-menu{
        left: unset !important;
        transform: unset !important;
        right: 0;
        top: 50% !important;
    }
    #${id}.hfc-mega-menu .hfc-mm-3{
        background-color: ${megaMenuBGcolor};
        padding: ${megaMenuPadding}px;
        border-radius: 10px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
        border-top: 5px solid ${megaMenuBorderColor};
        margin-top: 25px;
        width: ${megaMenuInnerWidth};
    }
    #${id} .hfc-main-header-3 .hfc-mm-3 .hfc-mm-col {
        display: flex;
        flex-direction: column;
    }
   .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label,
   .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label,
   .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label{
        position: relative;
        line-height: 30px;
        display: block;
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 5px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style:solid;
        border-color:${megaMenuDropdownColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after{
        border-color: ${megaMenuDropdownHoverColor};
    }
     #${id} .hfc-mm-3 .hfc-mm-cols{
        gap: 10px;
     }
    #${id} .hfc-mm-3 .hfc-icon-list-main .fp-ip-inner .fp-ip-icon{
        background-color: ${megaMenuIconBGColor}!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .fp-ip-inner svg{
        color: ${megaMenuIconColor}!important;
        height: ${megaMenuIconSize}px!important;
        width: ${megaMenuIconSize}px!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:not(:first-child):hover svg{
        color: ${megaMenuIconHoverColor}!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:not(:first-child):hover{
        background-color: ${megaMenuListBGColor};
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:not(:first-child) span{
        color: ${megaMenuLinksColor};
        font-size: ${megaMenuLabelSize}px;
        font-weight: normal;
     }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:first-child .fp-ip-inner span {
       color: ${megaMenuLinksColor}!important;
       font-size: calc(${megaMenuLabelSize}px + 4px)!important;
       font-weight: bold!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:first-child .fp-ip-inner svg {
      height: calc(${megaMenuIconSize}px + 4px)!important;
      width: calc(${megaMenuIconSize}px + 4px)!important;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:not(:first-child):hover span{
        color: ${megaMenuLinksHoverColor}!important;
     }
     #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:first-child .fp-ip-inner:hover span{
         color: ${megaMenuLinksColor}!important;
     }
     #${id} .hfc-mm-3 .hfc-icon-list-main .fp-ip-inner{
        gap: ${megaMenuContentGap}px;
        padding: calc(${megaMenuPadding}px - 15px);
    }
    #${id} .hfc-mm-3 .hfc-mm-col{
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        background-color: ${megaMenuBGcolor};
        border: 1px solid #ddd;
        border-radius: ${megaMenuListBorderRadius}px;
        padding: 10px;
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:not(:last-child){
        border-bottom: 1px solid ${megaMenuBottomBorderColor};   
    }
    #${id} .hfc-mm-3 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:first-child{
        border-bottom: none;   
    }
     #${id} .hfc-mm-3 .hfc-icon-list-main{
        gap: ${megaMenuListItemGap}px;
        margin-top: 0px;
   }
    @media (max-width: 599px){
        .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu a::after,
        .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu a::after,
        .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu a::after{
            display: none;
        }
    }`;

    return (
        <>
            <RawHTML>{`<style>${hfcmmDynamicStyles}</style>`}</RawHTML>
            <div id={id} data-menu-item-number={menuItemNum} className={'hfc-mega-menu'}>
                <InnerBlocks.Content />
            </div>
        </>
    )
}